import { LoginModel } from "./application/domain/login";


export const loginState: LoginModel = {
    email: '',
    password: '',
}